'use client';

import { useEffect, useState } from 'react';
import Accordion from '../Accordion';
import SurroundingsMapCheckBox from './CheckBox';
import { VillageSurrounding } from '@/services/types';
import { ISurroundingsMapDictionary } from '@/dictionaries/components/surroundingsMap/types';
import translateFromArray from '@/utils/get-translated-object';
import { useLocale } from '@/hooks/useLocale';

type Props = {
  dict: ISurroundingsMapDictionary;
  airportSurroundings: VillageSurrounding[];
  mapMarkersSurroundings: VillageSurrounding[];
  onCheckBoxChange: (surroundings: VillageSurrounding[]) => void;
};

export default function AirportsCheckBoxes({
  dict,
  airportSurroundings,
  mapMarkersSurroundings,
  onCheckBoxChange,
}: Props) {
  const [selectedAirport, setSelectedAirport] = useState<VillageSurrounding>();
  const [showAirports, setShowAirports] = useState(false);
  const lang = useLocale();

  const toggleAirports = () => setShowAirports((prev) => !prev);

  useEffect(() => {
    const filteredSurroundings = mapMarkersSurroundings.filter(
      ({ surrounding }) => {
        return surrounding.placeCategory.code !== 'airport';
      },
    );

    if (selectedAirport) {
      onCheckBoxChange([...filteredSurroundings, selectedAirport]);
    } else {
      onCheckBoxChange(filteredSurroundings);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAirport]);

  return (
    <Accordion
      isOpen={showAirports}
      toggle={toggleAirports}
      label={dict.airports.label}>
      <div className="flex flex-wrap">
        <div className="my-[10px]">
          {airportSurroundings.map((surrounding, index) => {
            const airportTranslation = translateFromArray({
              lang,
              translations: surrounding.surrounding.translate,
            });

            const airportName = airportTranslation?.title || '';
            return (
              <SurroundingsMapCheckBox
                key={index}
                id={`gm-airport-${surrounding.travelTime}`}
                label={airportName}
                onChange={() => {
                  if (selectedAirport === surrounding) {
                    return setSelectedAirport(undefined);
                  }
                  setSelectedAirport(surrounding);
                }}
                color="#999"
                isSelected={
                  selectedAirport?.travelTime === surrounding.travelTime
                }
              />
            );
          })}
        </div>
      </div>
    </Accordion>
  );
}
